const ProgressBar = (props) => {
  const { bgColor, completed, colorSchema } = props;

  let backgroundColor = "#e0e0de";
  if(completed === 0) {
    backgroundColor = "darkgray"
  }

  const containerStyles = {
    // height: 20,
    // width: '100%',
    backgroundColor: backgroundColor,
    borderRadius: 50,
    margin: 10
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: bgColor || colorSchema(completed),
    borderRadius: 'inherit',
    textAlign: 'right'
  }

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold'
  }

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;